import { useState } from 'react';

import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';

import { Tooltip } from '@mui/material';

import { Or2Button } from 'Components/button/Or2Button';

import { useGetFileUrl } from '@/modules/files/hooks/useGetFileUrl';

import type { RootOwner } from './FileSelectorDialog';
import { FileSelectorDialog } from './FileSelectorDialog';

interface Props {
  rootOwner: RootOwner;
  displayText: string;
  parentId: string | null | undefined;
  setDisplayText: React.Dispatch<React.SetStateAction<string>>;
  setUrl: React.Dispatch<React.SetStateAction<string>>;
  setParentId: (parentId: string | undefined | null) => void;
}

export const FileSelectorButton = ({
  rootOwner,
  displayText,
  parentId,
  setDisplayText,
  setUrl,
  setParentId,
}: Props) => {
  const [filePickerOpen, setFilePickerOpen] = useState(false);
  const getFileUrl = useGetFileUrl({
    type: rootOwner.type,
    machineName: rootOwner.machineName ?? '',
  });

  return (
    <>
      <Tooltip title="Browse for a file or folder">
        <Or2Button color="secondary" onClick={() => setFilePickerOpen(true)}>
          <FolderOpenOutlinedIcon />
        </Or2Button>
      </Tooltip>
      <FileSelectorDialog
        rootOwner={rootOwner}
        open={filePickerOpen}
        parentId={parentId}
        setParentId={setParentId}
        onClose={() => setFilePickerOpen(false)}
        onSelect={(fileId, _ownerId, file) => {
          if (!(fileId && file)) return;

          if ('filename' in file && displayText === '') {
            setDisplayText(String(file.filename));
          }

          if (file?.url) {
            setUrl(String(file.url));
          } else {
            setUrl(getFileUrl(file));
          }

          setFilePickerOpen(false);
        }}
      />
    </>
  );
};
